module.exports = __webpack_public_path__ + "img/icon_wuxingbi_title.fd547b01.png";